import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import "../../../styles/admins/invoices/invoice.css";
import { useNavigate } from "react-router-dom";

function PoliceReportPrint(props) {
    const navigate = useNavigate();
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({
    contentRef,
    onAfterPrint: () => {
      window.location.reload();
    },
  });

  window.onpopstate = (e) => {
    props.toggleHeader();
  };


  const clientIs = localStorage.getItem("client_is");
  const clientDetails = JSON.parse(clientIs);

const isValid = (v) =>
  v && v.trim() !== "" && v.toLowerCase() !== "na";

  return (
    <section className="d-flex flex-column align-items-center">
      {/* <h2 style={{ color: "white" }}>Reports</h2> */}
      <div
        className="invoice-outer col-12 report-outer d-block"
        ref={contentRef}
      >
          <div className="d-flex align-items-center mr-1">
            {/* <img
              src={clientDetails.image}
              alt=""
              style={{
                height: "90px",
                width: "90px",
                marginRight: "15px",
                marginLeft: "40px",
              }}
            /> */}
            <div className="invoice-header">
              <h2 style={{ fontSize: "28px" }}>
                POLICE REPORT
              </h2>  
              <hr />
              <br />
                          <h2 style={{ fontSize: "22px" }}>
                {clientDetails.business_name.toUpperCase()}
              </h2>
              {clientDetails.tagline && (
                <p>{clientDetails.tagline.toUpperCase()}</p>
              )}
              <p>{clientDetails.address.toUpperCase()}</p>
              <p style={{ fontSize: "15.5px" }}>
                Contacts: {clientDetails.contact}
              </p>
              {clientDetails.email && (
                <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                  {clientDetails.email}
                </p>
              )}
            </div>
          </div>

<div className="registrations py-1">
  <span>From: {props.startDate ? new Date(props.startDate).toLocaleDateString() : ""}</span>
  <span>To: {props.endDate ? new Date(props.endDate).toLocaleDateString() : ""}</span>
</div>

                      <div className="registrations py-1">
                              {clientDetails.gstin_show == '1' ?
              clientDetails.gstin !== null && (
                <p>GSTIN: {clientDetails.gstin}</p>
              ): (<p></p>)
            }
              {clientDetails.fssai !== null && clientDetails.fssai && (
                <p>FSSAI No.: {clientDetails.fssai}</p>
              )}
              {clientDetails.oyo_reg !== null && clientDetails.oyo_reg && (
                <p>OYO Reg No.: {clientDetails.oyo_reg}</p>
              )}
            </div>

        <div className="invoice-details">
          <table className="invoice-table report-table">
            <thead style={{ backgroundColor: "#1111" }}>
              <tr>
                {/* <th>Invoice No</th> */}
                <th>Guest Name</th>
                <th>Guest Contact</th>
                <th>Id Proof</th>
                <th>Gender</th>
                <th>Address</th>
                <th>Room No</th>
                                <th>Location</th>
                {/* <th>To Location</th> */}
                <th>Check-in Date</th>
                <th>Check-out Date</th>
                {/* {props.id === 6 ? <th>Entry No</th> : <th>Status</th>}
                <th>Room Rent</th>
                <th>CGST Amount</th>
                <th>SGST Amount</th>
                <th>Total Amount</th> */}
              </tr>
            </thead>
            <tbody>
              {props.reports.map((report) => (
                <tr key={report.booking_id}>
                  {/* <td>{report.inv_no ?? report.booking_id}</td> */}
<td>
  {report.guests.map((g, i) => (
    <div key={i}>{g.name}</div>
  ))}
</td>
<td>
  {report.guests.map((g, i) => (
    <div key={i}>{g.contact}</div>
  ))}
</td>
<td>
  {report.guests.map((g, i) => (
    <div key={i}>{g.identity_proof || '-'}</div>
  ))}
</td>

<td>
  {report.guests.map((g, i) => (
    <div key={i}>{g.gender || '-'}</div>
  ))}
</td>

<td>
  {report.guests.map((g, i) => (
    <div key={i}>{g.address}</div>
  ))}
</td>
                  <td>{report.room_no}</td>
<td>
  {(isValid(report.from_location) || isValid(report.to_location)) ? (
    <>
      From: {isValid(report.from_location) ? report.from_location : "-"}<br />
      To: {isValid(report.to_location) ? report.to_location : "-"}
    </>
  ) : "-"}
</td>
                  {/* <td>{report.to_location || '-'}</td> */}
                  <td>{new Date(report.from_date).toLocaleString()}</td>
                  <td>{new Date(report.to_date).toLocaleString()}</td>
                  {/* {props.id === 6 ? (
                    <td>{report.remarks}</td>
                  ) : (
                    <td>
                      {report.checkout_status ? "Checked Out" : "Checked In"}
                    </td>
                  )}
                  <td>₹{report.total_amount}</td>
                  <td>₹{(parseFloat(report.tax_amount) / 2).toFixed(2)}</td>
                  <td>₹{(parseFloat(report.tax_amount) / 2).toFixed(2)}</td>
                  <td>
                    ₹
                    {(
                      parseFloat(report.total_amount) +
                      parseFloat(report.tax_amount)
                    ).toFixed(2)}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <br />

      <div className="d-flex">
<button
  className="print-btn me-3"
 onClick={() => props.setShowPoliceReportPrint(false)}>
  Go Back
</button>
      <button className="print-btn" onClick={reactToPrintFn}>
        Print Report
      </button>
      </div>
    </section>
  );
}

export default PoliceReportPrint;
